import { featuresEnum } from '@/utils/featureUtils'

const TheContainerFluid = () => import('@/containers/TheContainerFluid')
const AutomationNew = () => import('./pages/AutomationNew')
const AutomationList = () => import('./pages/AutomationList')
const AutomationDate = () => import('./pages/AutomationDate')
const AutomationWorkflow = () => import('./pages/AutomationWorkflow')
const AutomationStatistics = () => import('./pages/AutomationStatistics')
const AutomationStatisticsProperty = () => import('./pages/AutomationStatisticsProperty')

const automationRoutes = [
  {
    path: 'automation',
    component: TheContainerFluid,
    children: [
      {
        path: '/',
        name: 'automationNew',
        component: AutomationNew,
        meta: { requiresAuth: true, feature_flag: featuresEnum.AUTOMATION },
      },
      {
        path: 'date',
        name: 'automationDate',
        component: AutomationDate,
        meta: { requiresAuth: true, feature_flag: featuresEnum.AUTOMATION },
      },
      {
        path: 'list',
        name: 'automationList',
        component: AutomationList,
        meta: { requiresAuth: true, feature_flag: featuresEnum.AUTOMATION },
      },
      {
        path: 'workflow/:workflowId',
        name: 'automationWorkflow',
        component: AutomationWorkflow,
        meta: { requiresAuth: true, feature_flag: featuresEnum.AUTOMATION },
      },
      {
        path: 'workflow/:workflowId/statistics',
        name: 'automationStatistics',
        component: AutomationStatistics,
        meta: { requiresAuth: true, feature_flag: featuresEnum.AUTOMATION },
      },
      {
        path: 'workflow/:workflowId/statistics/:statisticType',
        name: 'automationStatisticsProperty',
        component: AutomationStatisticsProperty,
        meta: { requiresAuth: true, feature_flag: featuresEnum.AUTOMATION }
      },
    ],
  },
]

export default automationRoutes
